'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = require('./Box');

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Segment = function (_Component) {
  _inherits(Segment, _Component);

  function Segment() {
    _classCallCheck(this, Segment);

    return _possibleConstructorReturn(this, (Segment.__proto__ || Object.getPrototypeOf(Segment)).apply(this, arguments));
  }

  _createClass(Segment, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          raised = _props.raised,
          loading = _props.loading,
          clearing = _props.clearing,
          fluid = _props.fluid,
          flatted = _props.flatted,
          borderless = _props.borderless,
          basic = _props.basic,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['raised', 'loading', 'clearing', 'fluid', 'flatted', 'borderless', 'basic', 'className']);

      var cx = (0, _classnames2.default)({
        raised: raised,
        loading: loading,
        clearing: clearing,
        fluid: fluid,
        flatted: flatted,
        borderless: borderless,
        basic: basic
      }, 'segment', className);

      return _react2.default.createElement(_Box2.default, _extends({
        ts: true,
        className: cx
      }, rest));
    }
  }]);

  return Segment;
}(_react.Component);

Segment.displayName = 'Segment';

Segment.propTypes = {
  raised: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  clearing: _propTypes2.default.bool,
  fluid: _propTypes2.default.bool,
  flatted: _propTypes2.default.bool,
  borderless: _propTypes2.default.bool,
  basic: _propTypes2.default.bool
};

exports.default = Segment;
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNlZ21lbnQuanMiXSwibmFtZXMiOlsiU2VnbWVudCIsInByb3BzIiwicmFpc2VkIiwibG9hZGluZyIsImNsZWFyaW5nIiwiZmx1aWQiLCJmbGF0dGVkIiwiYm9yZGVybGVzcyIsImJhc2ljIiwiY2xhc3NOYW1lIiwicmVzdCIsImN4IiwiZGlzcGxheU5hbWUiLCJwcm9wVHlwZXMiLCJib29sIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7O0lBRU1BLE87Ozs7Ozs7Ozs7OzZCQUNLO0FBQUEsbUJBV0gsS0FBS0MsS0FYRjtBQUFBLFVBRUxDLE1BRkssVUFFTEEsTUFGSztBQUFBLFVBR0xDLE9BSEssVUFHTEEsT0FISztBQUFBLFVBSUxDLFFBSkssVUFJTEEsUUFKSztBQUFBLFVBS0xDLEtBTEssVUFLTEEsS0FMSztBQUFBLFVBTUxDLE9BTkssVUFNTEEsT0FOSztBQUFBLFVBT0xDLFVBUEssVUFPTEEsVUFQSztBQUFBLFVBUUxDLEtBUkssVUFRTEEsS0FSSztBQUFBLFVBU0xDLFNBVEssVUFTTEEsU0FUSztBQUFBLFVBVUZDLElBVkU7O0FBWVAsVUFBSUMsS0FBSywwQkFDUDtBQUNFVCxzQkFERjtBQUVFQyx3QkFGRjtBQUdFQywwQkFIRjtBQUlFQyxvQkFKRjtBQUtFQyx3QkFMRjtBQU1FQyw4QkFORjtBQU9FQztBQVBGLE9BRE8sRUFVUCxTQVZPLEVBV1BDLFNBWE8sQ0FBVDs7QUFjQSxhQUNFO0FBQ0UsZ0JBREY7QUFFRSxtQkFBV0U7QUFGYixTQUdNRCxJQUhOLEVBREY7QUFPRDs7Ozs7O0FBR0hWLFFBQVFZLFdBQVIsR0FBc0IsU0FBdEI7O0FBRUFaLFFBQVFhLFNBQVIsR0FBb0I7QUFDbEJYLFVBQVEsb0JBQVVZLElBREE7QUFFbEJYLFdBQVMsb0JBQVVXLElBRkQ7QUFHbEJWLFlBQVUsb0JBQVVVLElBSEY7QUFJbEJULFNBQU8sb0JBQVVTLElBSkM7QUFLbEJSLFdBQVMsb0JBQVVRLElBTEQ7QUFNbEJQLGNBQVksb0JBQVVPLElBTko7QUFPbEJOLFNBQU8sb0JBQVVNO0FBUEMsQ0FBcEI7O2tCQVVlZCxPIiwiZmlsZSI6IlNlZ21lbnQuanMiLCJzb3VyY2VSb290IjoiRDpcXFByb2plY3RzXFxyZWFjdC10b2Nhc1xcc3JjIn0=



//////////////////
// WEBPACK FOOTER
// ../lib/Segment.js
// module id = 573
// module chunks = 0